<template class="bg-variant h-full">
  <div class="width" v-if="!loading">
    <div>
      <div class=" self-center  p-xl-12 p-ms-5">
        <div class=" p-jc-between p-grid">
        <p class=" font-bold mr-2 text-3xl "> Détails du projet:</p>
          <Button @click="$router.push({path: `/projects/${project.id}/settings`})" v-if="ifAdminOfProjet" label=" Paramètres du projet" class="p-button-rounded  mx-2">
          </Button>
        </div>
        <p class="subheading mr-2 text-2xl"> {{ project.title }}</p>
        <div class="pt-5 mt-2 mb-4">
          <p class="subheading mr-2 text-2xl p-text-bold mb-2"> Description:</p>
          <p v-if="project.description" class="subheading mr-2 text-1xl">
            {{ project.description }}</p>
          <p v-else class="subheading mr-2 text-1xl"> Pas de description !</p>
        </div>
      </div>
    </div>
    <div id="editing">
      <div id="files" class="w-full flex items-center shadow">
        <div class="tab-file tab-html px-8 py-2 cursor-pointer"
             :class="{ 'active': selectedTab === 'Utilisateurs' }"
             @click="selectEditingTab('Utilisateurs')">
            <span class="flex items-center">
              <span> <v-mdi name="mdi-account" id="icon-css" class="mr-2" height="18" width="20"></v-mdi>
                Utilisateurs
              </span>
            </span>
        </div>
        <div class="tab-file tab-css px-8 py-2 cursor-pointer"
             :class="{ 'active': selectedTab === 'Groupes' }"
             @click="selectEditingTab('Groupes')">
            <span class="flex items-center">
              <v-mdi name="mdi-account-multiple" id="icon-css" class="mr-2" height="18" width="20"></v-mdi>
              Groupes
            </span>
        </div>
      </div>
    </div>
    <div v-if="selectedTab === 'Groupes'" >
      <ProjectShowGroupes></ProjectShowGroupes>
    </div>
    <div v-else-if="selectedTab === 'Utilisateurs'" >
      <UsersList :members="project.members"></UsersList>
    </div>
  </div>
  <div v-else>
  <ProjetShowSkeleton></ProjetShowSkeleton>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import UsersList from "./Utilisateur/UsersList";
import ProjectShowGroupes from "./ProjectShowGroupes";
import ProjetShowSkeleton from "../../admin/projects/ProjetShowSkeleton"
export default {
  components: {
    ProjetShowSkeleton,
    UsersList,
    ProjectShowGroupes
  },
  data() {
    return {
      selectedTab: 'Utilisateurs',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      project: 'projects/getCurrent',
      user_id: 'auth/id'
    }),
    selectedFile() {
      return this.files.filter((file) => file.code === this.selectedTab)[0];
    },
    idProject() {
      return this.$route.params.idProject
    },
    ifAdminOfProjet() {
      return this.project.members.some(members => members.pivot.user_id === this.user_id && members.pivot.is_admin === 1)
    },
  },
  methods: {
    selectEditingTab(tab) {
      this.selectedTab = tab;
    },
  },
  async created() {
    this.loading = true
    await this.$store.dispatch('projects/fetchCurrentProject', this.idProject).then(res => {
      this.loading = false
    })

    if (!this.project.members.some(members => members.id === this.user_id)) {
      this.$router.push({ name: '401 Non autorisé' })
    }
  }
}
</script>

<style scoped lang="scss">
#editing {
  #files {
    .tab-file {
      border-bottom: 2px solid transparent;
      color: var(--text-light);
      transition: all .3s;

      &.tab-html {
        #icon-html {
          color: #d45632;
        }

        &.active {
          border-color: #d45632;
        }
      }

      &.tab-css {
        #icon-css {
          color: #2652dc;
        }

        &.active {
          border-color: #2652dc;
        }
      }

      &.tab-js {
        #icon-js {
          color: #f0db4f;
        }

        &.active {
          border-color: #f0db4f;
        }
      }

      &.active {
        color: var(--text-white);
        background-color: var(--bg-input);
      }
    }
  }

  #code {
    .tab-code {
      display: none;

      &.active {
        display: block;
      }
    }
  }
}
</style>
